export const faviconUrl = 'https://cdn.myfunnow.com/web/images/funnow_favicon.svg'

export enum ResponseCode {
  Success = 0,
  InvalidParameters = 10,
  /**
   * Need Redirect to Login
   */
  Unauthorized = 11,
  /**
   * 找不到 Token
   * 可能是不存在、已被刪除或是過期
   */
  TokenNotFound = 16,
  ACCOUNT_HAS_BEEN_REGISTERED = 17,
  WrongOldPassword = 32,
  /** 方案已賣完 */
  ProductSoldOut = 42,
  PRODUCT_SOLD_OUT = 42,
  InvalidHeaders = 66,
  WrongAccountOrPassword = 100,
  PAYMENT_CARD_INVALID = 233,
  /** 訂單已兌換 */
  IsRedeem = 303,
  IsReschedulableExpired = 305,
  IsReschedulableProduct = 306,
  IsReschedulableCrossday = 307,
  GroupOrderNotExist = 323,
  ORDER_DUPLICATE = 327,
  BRANCH_BLOCK_USER = 329,
  NonProductSpecificCard = 338,
  /** 手機條碼不存在或格式錯誤（ZOEKIT-17957） */
  InvalidMobileBarcode = 341,
  NeedUpdate = 426,
  InternalSeverError = 500,
  Forbidden = 513,
  STRIPE_PAYMENT_CONFIRM = 1101,
  PAYMENT_SUCCESS = 1200,
  /** 空位不足 */
  NotEnoughResource = 1400,
  PaymentPromoInvalid = 4900,

  /** USEN 無座位 */
  SEATS_NOT_EXIST = 5402,
}

export enum Gender {
  Female,
  Male,
  Other,
}

export type WeekdayShortText = 'Sun' | 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat'

export type ResultVM = {
  code: number
  message: string
  timezone?: string
  total_count?: number
  [key: string]: any
}

export interface ResultGenericVM<T> extends ResultVM {
  data: T
}

export interface ResultListGenericVM<T> extends ResultVM {
  data: T[]
}

export class ResultError extends Error {
  code: number
  override message: string
  constructor(code: number, message: string) {
    super()
    this.code = code
    this.message = message
  }
}

export type TimeRange<T = number> = { start: T; end: T }
/** the mode for display date of booking */
export enum TimeMode {
  SevenDays,
  Calendar,
}

export enum abbrLocaleToZhEnMap {
  zh = 'zh',
  cn = 'en',
  ja = 'zh',
  en = 'en',
  th = 'en',
}

export enum BannerUiType {
  BANNER = 'banner',
  CATEGORY = 'category',
}

export enum BannerActionType {
  None,
  Url,
  PageLink,
  FromCurrentPage,
}
export interface Banner {
  id?: number
  link_type?: BannerActionType
  link_target?: string
  cover_image?: string
  description?: string
  title?: string
}

/**
 * 至少存在該型別的一個 properties
 * @reference https://learn.microsoft.com/en-us/javascript/api/@azure/keyvault-certificates/requireatleastone?view=azure-node-latest
 */
export type RequireAtLeastOne<T> = { [K in keyof T]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<keyof T, K>>> }[keyof T]

/**
 * 讓所有的 properties (包含 deep) 都變成 optional
 * @ref https://stackoverflow.com/questions/47914536/use-partial-in-nested-property-with-typescript
 */
export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends object ? RecursivePartial<T[P]> : T[P]
}

/**
 * 除了指定的 key 外，讓其他的 properties (包含 deep) 都變成 optional
 * @ref https://stackoverflow.com/questions/47914536/use-partial-in-nested-property-with-typescript
 */
export type PartialExcept<T, K extends keyof T> = RecursivePartial<T> & Pick<T, K>

export type AlertType = 'success' | 'error'

type CamelToSnakeCase<S extends string> = S extends `${infer T}${infer U}`
  ? U extends Uncapitalize<U>
    ? `${Lowercase<T>}${CamelToSnakeCase<U>}`
    : `${Lowercase<T>}_${CamelToSnakeCase<Uncapitalize<U>>}`
  : S

// 主轉換器：保留非 string key
export type ToSnakeCaseKeys<T> = {
  [K in keyof T as K extends string ? CamelToSnakeCase<K> : K]: T[K]
}
